import styled from 'styled-components';

export const Container = styled.div`
  max-height: 1000px;
`;
